export default __webpack_public_path__ + "static/media/fourteen.6c1bbb60.png";